/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Paper from "@mui/material/Paper";
import Link from "next/link";
import { useState } from "react";
import { menu } from "./Menu";
import { useParams } from "next/navigation";
import { useTranslation } from "../../../i18n/client";
export default function MobileMenu() {
    const params = useParams();
    const [value, setValue] = useState("");
    const { t } = useTranslation(params ? params.lng : "en", "landing-sidebar");
    const currentLng = (params === null || params === void 0 ? void 0 : params.lng) === "de" ? "de" : "en";
    const localizedPath = (path)=>"/".concat(currentLng).concat(path.startsWith("/") ? path : "/".concat(path));
    return /*#__PURE__*/ _jsx(Paper, {
        sx: {
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            width: "100%",
            maxWidth: "100vw",
            overflow: "hidden",
            paddingY: "4px",
            paddingX: 0,
            paddingBottom: "calc(4px + env(safe-area-inset-bottom))",
            zIndex: 10
        },
        elevation: 3,
        children: /*#__PURE__*/ _jsx(BottomNavigation, {
            showLabels: true,
            value: value,
            onChange: (event, newValue)=>{
                setValue(newValue);
            },
            sx: {
                width: "100%",
                maxWidth: "100%",
                "& .MuiBottomNavigationAction-root": {
                    position: "relative",
                    minWidth: "0 !important",
                    maxWidth: "20%",
                    flex: "1 1 0",
                    padding: "4px 2px",
                    "& .MuiBottomNavigationAction-label": {
                        fontSize: "7px !important",
                        lineHeight: 1.15,
                        paddingTop: "6px !important",
                        color: "#000",
                        whiteSpace: "normal",
                        textAlign: "center",
                        maxWidth: "100%"
                    },
                    "& .MuiSvgIcon-root": {
                        fontSize: "20px"
                    }
                }
            },
            children: menu.map((it, index)=>/*#__PURE__*/ _jsx(BottomNavigationAction, {
                    LinkComponent: Link,
                    href: localizedPath(it.link),
                    sx: {
                        ":before": {
                            position: "absolute",
                            content: '""',
                            bottom: "-2px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            height: "4px",
                            width: "80%",
                            maxWidth: "48px",
                            background: "".concat(index) === "".concat(value) ? "#FF9F24" : "#fff",
                            borderRadius: "20px"
                        }
                    },
                    label: t(it.name),
                    icon: /*#__PURE__*/ _jsx(it.icon, {
                        color: "".concat(index) === "".concat(value) ? "#FF9F24" : ""
                    })
                }, it.name))
        })
    });
}
